import { useQuery } from '@tanstack/react-query'
import {
  type AlbumSelection,
  canFetchCuratedAlbum,
  decodeAlbumSelection,
} from '@/lib/photos/album-selection'
import { photosService } from '@/api/services/photos.service'
import { queryKeys } from '@/api/query-keys'

function canFetchAlbumPhotos(
  selection: AlbumSelection | null,
  spreadId?: string | null
): selection is AlbumSelection {
  if (!selection) return false
  if (selection.type === 'album') return true
  return canFetchCuratedAlbum(selection.key, spreadId)
}

export function useAlbumPhotosQuery(albumValue: string | null, spreadId?: string | null) {
  const selection = decodeAlbumSelection(albumValue)

  return useQuery({
    queryKey: queryKeys.photos.albumPhotos(albumValue, spreadId),
    queryFn: () => photosService.getPhotosForSelection(selection!, { spreadId }),
    enabled: canFetchAlbumPhotos(selection, spreadId),
    staleTime: 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
